<template>
    <transition name="modal">
        <div>
            <div class="modal-mask">
                <div class="modal-wrapper" @click="$emit('close')">
                    <div class="modal-container" @click.stop="">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content" :class='{isTpg: isTpg}'>
                                <div class="modal-title" style="margin-bottom:30px;">
                                    <span>Custom Mixes</span>
                                    <div class="close-modal" @click="$emit('close')" :class='{isTpg: isTpg}'>
                                        <font-awesome-icon icon="times" aria-hidden="false" />
                                    </div>
                                </div>

                            <div v-if="step == 'YESNO'">
                                Want to mix it up for a bit?
                                <div class="buttonContainer">
                                    <button @click="theyWantToMixItUp">Yes</button>
                                    <button @click="theyDontWantToMixItUp">No</button>
                                </div>
                            </div>

                            <div v-else-if="step == 'SHOWMIXES'" class="showMixes">

                                <div v-if="selectedMix.id != 'auto' || showReturnToDailyButton == true" class="dailyTitle">
                                    You are currently playing a Custom Mix. <br> Click below to switch back to your daily playlist.

                                    <div class="return-button" @click="returnToDaily()" :class="{isTpg:isTpg}">
                                        Return to your daily mix
                                    </div>
                                </div>

                                <div v-else class="dailyTitle">
                                    <span v-if="customMixes && customMixes.length > 1">
                                Choose one of the following Custom Mixes.
                            </span>
                                    <span v-else>
                                Choose the Custom Mix below to switch it up:
                            </span>
                                </div>

                                <div class="custom-mix-row-container" id="custom-scrollbar">

                                    <div v-for="mix in customMixes" :key="mix.id" class="custom-mix-row" :class="{selectedRow: mix.id == selectedMix.id,onlyOneRow: customMixes.length < 2, isTpg:isTpg}" @click="selectMix(mix)">
                                        <div>
                                            {{ mix.name }}
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <div v-else-if="step == 'LOADING'">
                                <p>Please wait while we load {{ mixNameString }} . This may take a few moments.</p>
                                <div class="spinner">
                                    <div class="rect1"></div>
                                    <div class="rect2"></div>
                                    <div class="rect3"></div>
                                    <div class="rect4"></div>
                                    <div class="rect5"></div>
                                </div>
                                <br><br>
                            </div>

                            <div v-else class="durationContainer">
                                <p>
                                    {{newMix.name}} Custom Mix is <b>{{secondsToHours(newMix.duration)}}</b> long. How long would you like for it to play?
                                </p>
                                <select v-model="selectedDuration" class="dropdown">
                            <option v-for="option in durationOptions" :key="option.value">{{ option.value }}</option>
                        </select>
                                <div class="form-field" v-if="selectedMix && selectedMix.user_can_shuffle == '1' && canShuffleOnPlayer == '1'">
                                    <input type="checkbox" id="shouldShuffle" v-model="shouldShuffle">
                                    <label for="shouldShuffle">&nbsp;&nbsp;Shuffle Tracks</label>
                                </div>
                                <div class="buttonContainer">
                                    <button @click="confirm">Play</button>
                                    <button @click="cancel">Cancel</button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
    </transition>
</template>

<script>

export default {
  data() {
    return {
      selectedDuration: '',
      yesNoClicked: true,
      showDuration: false,
      newMix: '',
      loadingMix: false,
      shouldShuffle: false,
    };
  },
  props: ['custom-mixes', 'selected-mix', 'reset-mix-modal', 'is-tpg', 'can-shuffle-on-player', 'is-vp', 'show-return-to-daily-button'],
  mounted() {
    this.selectedDuration = '';
    this.loadingMix = false;
  },
  methods: {
    theyWantToMixItUp() {
      this.yesNoClicked = true;
    },
    theyDontWantToMixItUp() {
      this.$$emit('close');
    },
    selectMix(mix) {
      this.newMix = mix;
      this.showDuration = true;
    },
    confirm() {
      if (this.selectedMix.shuffle == 1) {
        this.shouldShuffle = 1;
      }

      // If previous mix was a daily, then need to shuffle
      // This takes precedence over client shuffle checkbox
      if (this.selectedMix.id == 'auto') {
        this.shouldShuffle = 1;
      }

      this.$emit('newMixSelected', this.newMix, this.selectedDuration, this.shouldShuffle);
      this.loadingMix = true;
      this.shouldShuffle = 0;
      // $('#selectMixModal').modal('hide')
    },
    cancel() {
      this.shouldShuffle = 0;
      this.$emit('close');
    },
    returnToDaily() {
      const mix = { name: 'Daily Playlists', id: 'auto' };
      this.newMix = mix;
      this.$emit('newMixSelected', mix, '');
      this.loadingMix = true;
      this.yesNoClicked = true;
    },
    secondsToHours(d) {
      d = Number(d);
      const h = Math.floor(d / 3600);
      const m = Math.floor(d % 3600 / 60);
      const s = Math.floor(d % 3600 % 60);

      const hDisplay = h > 0 ? h + (h == 1 ? ' hour, ' : ' hours, ') : '';
      const mDisplay = m > 0 ? m + (m == 1 ? ' minute, ' : ' minutes, ') : '';
      const sDisplay = s > 0 ? s + (s == 1 ? ' second' : ' seconds') : '';
      return hDisplay + mDisplay + sDisplay;
    },
  },
  computed: {
    dialogContent() {
      if (this.selectedMix) {
        return `${this.selectedMix.name} Custom Mix is ${this.secondsToHours(this.selectedMix.duration)} long.  How long would you like for it to play?`;
      }

      return '';
    },
    durationOptions() {
      const options = [{ value: 'Play through once' }];

      const hours = Math.floor(this.newMix.duration / 3600);
      for (let i = 0; i < hours; i++) {
        const out = (i + 1) + ((i + 1) == 1 ? ' Hour' : ' Hours');
        options.push({ value: out });
      }

      // Check if VP or not.
      if (this.selectedMix.loop_forever === true || this.selectedMix.loop_forever === 'true') {
        options.push({ value: 'Loop Forever' });
      }

      return options;
    },
    /**
    * Returns which step of the select custom mix to display: yes or no, select mix, or select duration
    */
    step() {
      if (!this.selectedMix) {
        return;
      }

      if (!this.yesNoClicked && this.selectedMix.id === 'auto') {
        return 'YESNO';
      } if ((this.yesNoClicked && !this.showDuration && !this.loadingMix) || (!this.yesNoClicked && !this.newMix)) {
        return 'SHOWMIXES';
      } if (this.loadingMix) {
        return 'LOADING';
      }
      return 'SHOWDURATION';
    },
    mixNameString() {
      if (this.newMix.id == 'auto') {
        return 'Daily Playlist';
      }
      return `${this.newMix.name} Custom Mix`;
    },
  },
  watch: {
    resetMixModal() {
      this.showDuration = false;
      this.loadingMix = false;
      this.newMix = '';
    },
    durationOptions() {
      this.selectedDuration = 'Play through once';
    },
  },
};
</script>

<style scoped>
.modal-content {
    background: rgba(72,70,77,.9);
    color:white;
    padding:10px;
}

.modal-title {
    margin-top:-10px;
    margin-bottom:2px;
    color:#ccc;
}
.modal-title-container {

    border-bottom: 1px solid #666;
   margin-bottom:10px;
}
.media-body {
    padding:20px;
}

.buttonContainer {
    margin-top:20px;
    padding-bottom:20px;
}
.buttonContainer button {
    width: 75px;
}
.form-check input[type='checkbox'] {
  -webkit-appearance:none;
  width:14px;
  height:14px;
  border-radius:50%;
  outline:none;
  transition:.3s;
  border:1px solid #000;
}
.form-check input[type='radio'] {
  border:1px solid #000;
}
.form-check input[type='checkbox']:hover {
  box-shadow:0 0 5px 0px #fff inset;
}
.form-check input[type='checkbox']:before {
  content:'';
  display:block;
  width:60%;
  height:60%;
  margin: 20% auto;
  border-radius:50%;
}
.form-check input[type='checkbox']:checked:before {
  border:1px solid #000;
}

/* body select.select_box */
.durationContainer select {
    display: block; padding: 10px 70px 10px 13px !important;
    max-width: 100%;
    height: auto !important;
    border: 1px solid #e3e3e3;
    border-radius: 3px;
    background: url("../../../assets/images/arrow-down.png") right center no-repeat;
    background-color: #fff;
    color: #444444;
    font-size: 12px;
    line-height: 16px !important;
    appearance: none; /* this is must */
    -webkit-appearance: none; -moz-appearance: none;
    margin:0 auto;
    margin-top:20px;
}

/* body select.select_box option */
.durationContainer select option { padding: 0 4px; }
/* for IE and Edge */
select::-ms-expand { display: none; }
select:disabled::-ms-expand { background: #f60; }
*:focus {
   outline: 0;
 }

.dailyTitle {
    font-size:13px;
    text-align:center;
    padding:5px;
    width:100%;
    line-height:15px;
    margin-bottom:10px;
}
.custom-mix-row-container {
    padding-top:5px;
    margin-top:15px;
    max-height: 150px;
    overflow-y: auto;
    clear:left;
}
.custom-mix-row {
    border-top: 1px solid #efefef;
    height:44px;
    font-size: 12px;
    line-height: 44px;
    margin-right:20px;
    transition:0.3s;
    cursor: pointer;
    clear:both;
    text-align:left;
}
.custom-mix-row.onlyOneRow {
    border-top: 0;
}
.custom-mix-row:hover {
    color:yellow;
}
.custom-mix-row.isTpg:hover {
    color:rgba(1,172, 129,1);
}
.custom-mix-row:last-child {
    border-bottom: 0px;
}
.return-button {
    font-size: 14px;
    width:100%;
    height:32px;
    border-radius: 5px;
    line-height: 32px;
    padding-top:1px;
    cursor:pointer;
    text-align: center;
    color:white;
    background-color: rgba(125, 125, 125, 0.5);
    border: 0px solid white;
    transition: .3s;
    margin:0 auto;
    margin-top:20px;
}
.return-button:hover {
    background-color: rgba(27, 27, 27, 0.5);
    color:yellow
}
.return-button.isTpg:hover {
  color:rgba(1,172, 129,1);
}
.selectedRow {
    color:yellow;
    font-weight:bold;
}
.buttonContainer {
    margin-top:20px;
    padding-bottom:20px;
}
.buttonContainer button {
    width: 90px;
    color:black;
}
.close-modal {
    color: #666;
}.close-modal:hover {
    color: #fff;
}
.spinner {
  margin: 10px auto;
  width: 50px;
  height: 35px;
  text-align: center;
  font-size: 8px;
}

.spinner > div {
  background-color: #ccc;
  height: 100%;
  width: 5px;
  display: inline-block;
  -webkit-animation: sk-stretchdelay 1.2s infinite ease-in-out;
  animation: sk-stretchdelay 1.2s infinite ease-in-out;
  margin-left: 1px;
}

.spinner .rect2 {
  -webkit-animation-delay: -1.1s;
  animation-delay: -1.1s;
}

.spinner .rect3 {
  -webkit-animation-delay: -1.0s;
  animation-delay: -1.0s;
}

.spinner .rect4 {
  -webkit-animation-delay: -0.9s;
  animation-delay: -0.9s;
}

.spinner .rect5 {
  -webkit-animation-delay: -0.8s;
  animation-delay: -0.8s;
}
@-webkit-keyframes sk-stretchdelay {
  0%, 40%, 100% { -webkit-transform: scaleY(0.4) }
  20% { -webkit-transform: scaleY(1.0) }
}

@keyframes sk-stretchdelay {
  0%, 40%, 100% {
    transform: scaleY(0.4);
    -webkit-transform: scaleY(0.4);
  }  20% {
    transform: scaleY(1.0);
    -webkit-transform: scaleY(1.0);
  }
}

.modal-dialog {
    width: auto;
    max-width: 400px;
    margin: 0 auto;
    margin-top: 50px;
}

.modal-content {
    /* width:700px;
        margin:0 auto; */
    background: #666;
    color: white;
}

.close-modal {
  position: absolute;
  top: 0px;
  right: 10px;
  cursor: pointer;
  text-align: right;
  width:20px;
  height:20px;
  color:white;
}

.modal-container {
    box-shadow: 0 0px 0px rgba(0, 0, 0, 0.33);
}
</style>
